module.exports = __webpack_public_path__ + "img/zoom-02.83b793d1.webp";